import React from 'react';
import Typed from 'react-typed';
import { Link } from "react-router-dom";


const Hero = () => {
  return (
    <div className='text-white'>
      <div className='max-w-[800px] mt-[-96px] w-full h-screen mx-auto text-center flex flex-col justify-center'>
        <p className='text-[#c88bc4] font-bold p-2'>
          GROW WITH BETTER DATA
        </p>
        <h1 className='md:text-7xl sm:text-6xl text-4xl font-bold md:py-6'>
          Grow With Rapid
        </h1>
        <div className='flex justify-center items-center'>
          <p className='md:text-5xl sm:text-4xl text-xl font-bold py-4'>
            Better Data, Better
          </p>
          <Typed
          className='md:text-5xl sm:text-4xl text-xl font-bold md:pl-4 pl-2'
            strings={['Learning', 'Performance','Ai']}
            typeSpeed={120}
            backSpeed={220}
            loop
          />
        </div>
        <p className='md:text-2xl text-xl font-bold text-gray-500'>"Streamline your AI development with our comprehensive dataset solutions and expert management."</p>
        <Link to='/rasas'> <button className='bg-[#c88bc4] w-[200px] rounded-md font-medium my-6 mx-auto py-3 text-black'>RASAS Beta</button></Link>
      </div>
    </div>
  );
};

export default Hero;
